module.exports = __webpack_public_path__ + "img/album07_07.05501a33.jpg";